import React from 'react';
import Image from 'next/image';
import PropTypes from 'prop-types';
import Quotes from '../../../public/assets/Quotes.png';

export default function TestimonialCard({
  testimonial, isActive = false, isSide = false, pageName,
}) {
  const containerClasses = `bg-white ${
    isActive ? 'shadow-sm lg:shadow-[20px_6px_44px_0px_#00000005]' : ''
  } ${isSide ? 'lg:opacity-60' : 'lg:opacity-100'} transition-opacity`;
  return (
    <div
      className={`flex flex-col lg:flex-row gap-6 sm:gap-[27px] md:gap-[30px] lg:h-full w-full justify-start rounded-lg px-4 sm:px-[18px] md:px-5 py-4 sm:py-[18px] md:py-5 lg:border-0 h-full border border-[#DBF2FF]  ${containerClasses}`}
    >
      <div className={`${pageName === 'courseDetail' ? 'rounded-full lg:relative absolute lg:top-0 top-[-28px] flex justify-start lg:w-auto w-[88px]' : 'w-[82%] md:w-[70%] relative'} lg:self-center bg-[#b8e5ff]`}>
        <Image
          src={testimonial?.image}
          alt={testimonial?.name}
          className={`${pageName === 'courseDetail' ? 'rounded-full lg:w-[162px] w-[88px] aspect-square' : 'rounded-[10px] w-full h-[240px] sm:h-[270px] md:h-[302px] object-cover'}`}
          width={100}
          height={100}
        />
      </div>

      <div className="flex flex-col-reverse lg:flex-row justify-start w-full lg:mt-0 mt-9">
        <div className="">
          <p
            className={`text-xs lg:text-sm font-normal text-[#202020] line-clamp-3 lg:line-clamp-6 ${isActive ? 'text-justify pr-[6px] sm:pr-[7px] md:pr-[8px]' : 'text-left'} leading-[20px] sm:leading-[23px] md:leading-[26px]`}
          >
            {testimonial?.message}
          </p>

          <div className="flex flex-col gap-[3px] sm:gap-[3.5px] md:gap-[4px] mt-[14px] md:mt-[18px]">
            <h4 className="text-sm lg:text-lg font-semibold text-[#202020] uppercase leading-[20px] sm:leading-[22px] md:leading-[24px]">
              {testimonial?.name}
            </h4>
            {testimonial?.designation && (
            <p className="text-xs lg:text-sm font-mulish text-[#808080] leading-[15px] sm:leading-[16px] md:leading-[18px]">
              {testimonial?.designation}
            </p>
            )}
          </div>
        </div>
        <div className="lg:block justify-end flex lg:mt-0 mb-2 lg:w-[86px]">
          <Image src={Quotes} alt="Quote" className="w-[28px] lg:w-[29px] h-[20px]  lg:h-[21px]" width={100} height={100} />
        </div>
      </div>
    </div>
  );
}

TestimonialCard.propTypes = {
  testimonial: PropTypes.object,
  isActive: PropTypes.bool,
  pageName: PropTypes.any,
  isSide: PropTypes.bool,
};
